var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideoLesson(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 11,
    viewBox: "0 0 15 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.50065 0.0065918H11.5007C12.9734 0.0065918 14.1673 1.2005 14.1673 2.67326V5.51326C14.1673 6.98602 12.9734 8.17992 11.5007 8.17992H3.50065C2.02789 8.17992 0.833984 6.98602 0.833984 5.51326V2.67326C0.833984 1.2005 2.02789 0.0065918 3.50065 0.0065918ZM11.5007 7.06659C12.3585 7.06659 13.054 6.37114 13.054 5.51326V2.67326C13.054 1.81538 12.3585 1.11992 11.5007 1.11992H3.50065C2.64277 1.11992 1.94732 1.81538 1.94732 2.67326V5.51326C1.94732 6.37114 2.64277 7.06659 3.50065 7.06659H11.5007Z",
    fill: "#404A51"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1673 9.49316H3.83398C3.55784 9.49316 3.33398 9.71702 3.33398 9.99316C3.33398 10.2693 3.55784 10.4932 3.83398 10.4932H11.1673C11.4435 10.4932 11.6673 10.2693 11.6673 9.99316C11.6673 9.71702 11.4435 9.49316 11.1673 9.49316Z",
    fill: "#404A51"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoLesson);
export default __webpack_public_path__ + "static/media/VideoLesson.cb3f1df7399c9393bfbe15a37e73d3ba.svg";
export { ForwardRef as ReactComponent };